import api from '@/api/axios'

export const getGeneral = async () => {
  const response = await api.get(`/generals`)
  return response.data
}